/* ======================================================================== */
/* 66. elementor */
/* ======================================================================== */
/**
 * Elementor Preview
 */
window.$window.on('elementor/frontend/init', function () {

	if (typeof elementor !== 'undefined') {

		elementorFrontend.hooks.addAction('frontend/element_ready/global', function ($scope) {
			initComponents($scope);
			window.$body.removeClass('cursor-progress');
		});

	}

});
